import React from 'react'
import { MenuItem } from './MenuItem'
import { MegaMenuItem } from './types'
import { useTranslations } from 'next-intl'

type LinkListProps = {
  category: MegaMenuItem['categories'][0] | undefined
  hoveredLinkIndex: number | null
  setHoveredLinkIndex: (index: number) => void
  onLinkClick: () => void
  pathName: string
}

export const LinkList: React.FC<LinkListProps> = ({
  category,
  hoveredLinkIndex,
  setHoveredLinkIndex,
  onLinkClick,
}) => {
  const t = useTranslations('megaMenu')

  if (!category) return null

  return (
    <div className="mx-6 p-4 lg:min-w-80 min-w-[220px]">
      <h3 className="text-label-XS-regular text-text-faded mb-5 ps-4">{t('processes')}</h3>
      <div className="space-y-0.5 pb-8">
        {category.links.map((link, linkIndex) => {
          const isHovered = hoveredLinkIndex === linkIndex

          return (
            <MenuItem
              key={linkIndex}
              link={link}
              isHovered={isHovered}
              onClick={onLinkClick}
              onHover={() => setHoveredLinkIndex(linkIndex)}
            />
          )
        })}
      </div>
    </div>
  )
}
